import { useGeolocationUserLocationAdd } from './useGeolocationUserLocationAdd';

const GeoLocation = () => {
  useGeolocationUserLocationAdd();

  return null;
};

export default GeoLocation;
